import { BottomSheet } from "react-spring-bottom-sheet";

import invoiceCredit from "../../../assets/images/icon_invoice/InvoiceCredit.svg";
import invoiceCreditPartial from "../../../assets/images/icon_invoice/InvoiceCreditPartial.svg";
import invoiceNonCredit from "../../../assets/images/icon_invoice/InvoiceNonCredit.svg";
import autoDebetPartial from "../../../assets/images/icon_invoice/icon_autodebet/perdetail.svg";
import autoDebetNonCredit from "../../../assets/images/icon_invoice/icon_autodebet/noncredit.svg";
import autoDebetCredit from "../../../assets/images/icon_invoice/icon_autodebet/credit.svg";

type InvoiceWebInformationSheetProps = {
  open: boolean;
  onDismiss: () => void;
};

export const InvoiceWebInformationSheet = ({
  open,
  onDismiss,
}: InvoiceWebInformationSheetProps) => {
  return (
    <BottomSheet
      open={open}
      onDismiss={onDismiss}
      defaultSnap={({ snapPoints, lastSnap }) =>
        lastSnap ?? Math.min(...snapPoints)
      }
      snapPoints={({ maxHeight }) => [
        maxHeight - maxHeight / 5,
        maxHeight * 0.6,
      ]}
      header={
        <h1 className="font-poppins flex items-left text-sm font-bold text-black">
          Keterangan
        </h1>
      }
      footer={
        <button
          onClick={onDismiss}
          className="p-2 bg-danger rounded-lg w-full text-white"
        >
          Tutup
        </button>
      }
    >
      <div className="p-4">
        <div className="flex flex-column gap-2">
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={invoiceCredit} alt="" />
            <span>Tagihan Kredit</span>
          </div>
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={invoiceCreditPartial} alt="" />
            <span>Tagihan Kredit Per Detail</span>
          </div>
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={invoiceNonCredit} alt="" />
            <span>Tagihan Non Kredit</span>
          </div>
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={autoDebetCredit} alt="" />
            <span>Tagihan Auto Debet Kredit</span>
          </div>
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={autoDebetPartial} alt="" />
            <span>Tagihan Auto Debet Kredit Per Detail</span>
          </div>
          <div className="p-4 border-b border-b-silver flex items-center gap-4">
            <img src={autoDebetNonCredit} alt="" />
            <span>Tagihan Auto Debet Non Kredit</span>
          </div>
          <i>
            <span className="p-4">
              * Auto Debet: Tagihan terbayarkan secara otomatis ketika saldo
              mencukupi.
            </span>
          </i>
        </div>
      </div>
    </BottomSheet>
  );
};
